import React from "react";
import { Laptop, Megaphone, Signpost, Printer, PartyPopper, Code2, Briefcase, Palette, Wrench } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/common";
import { USE_CASES } from "@/data/content";

const ICON_MAP = { Laptop, Megaphone, Signpost, Printer, PartyPopper, Code2, Briefcase, Palette, Wrench };

export const UseCasesSection = () => {
  return (
    <section id="use-cases" data-testid="use-cases-section" className="relative py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading overline="Use cases" title="Made for project-based businesses." center />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {USE_CASES.map((c, i) => {
            const Icon = ICON_MAP[c.icon];
            return (
              <Reveal key={c.name} delay={(i % 3) * 0.06}>
                <div
                  data-testid={`use-case-${i}`}
                  className="group h-full bg-white rounded-2xl border border-slate-100 soft-shadow p-6 flex items-start gap-4 transition-transform duration-300 hover:-translate-y-1"
                >
                  <div className="h-11 w-11 rounded-xl bg-[#ecfdf3] flex items-center justify-center shrink-0 transition-transform duration-300 group-hover:scale-110">
                    <Icon className="h-5 w-5 text-[#16a34a]" />
                  </div>
                  <div>
                    <h3 className="font-display text-base font-bold text-[#091630]">{c.name}</h3>
                    <p className="text-sm text-slate-500 mt-1">{c.line}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default UseCasesSection;
